// Floating labels
export const floatingLabels = () => {
	const fls = document.querySelectorAll('.v-form__floating-label');
	if (fls.length) {
		const floatingInputs = [...fls].map((l) => {
			const wrap = l.parentElement;
			return wrap.querySelector('input, select, textarea');
		});

		[...floatingInputs].forEach((field, i) => {
			field.addEventListener('focusin', () => {
				fls[i].classList.add('v-form__floating-label--active');
			});

			field.addEventListener('focusout', () => {
				if (!field.value) {
					fls[i].classList.remove('v-form__floating-label--active');
				}
			});

			field.addEventListener('change', () => {
				if (!field.value) {
					fls[i].classList.remove('v-form__floating-label--active');
				}
			});

			const fieldObserver = new MutationObserver((e) => {
				if (!field.value) {
					fls[i].classList.remove('v-form__floating-label--active');
				}
			});
			fieldObserver.observe(field, { attributes: true });
		});
	}
};
